export const getFileInputId = (variantId: number): string => {
  return `file-upload-new-${variantId}`
}

